import { Moment } from 'moment-timezone';

import { OrganizationFile } from './organization-file';

export class EmailTemplate
{
    id?: number;
    organizationId?: number;
    subject: string;
    message: string;
    attachments?: OrganizationFile[];
    attachmentIds?: number[];

    createdAt?: Moment;

    constructor(request: any) {
        this.id = request.id;
        this.organizationId = request.organizationId;
        this.subject = request.subject;
        this.message = request.message;

        this.attachments = request.attachments || [];
        this.attachmentIds = request.attachmentIds || [];

        this.createdAt = request.createdAt;
    }
}
